import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-personnel-list',
  templateUrl: './personnel-list.component.html',
  styleUrls: ['./personnel-list.component.css'],
})
export class PersonnelListComponent {
  url: string = 'accountings/users/list';
  urlTwo: string = 'accountings/freelancers/list';
  urlThree: string = 'accountings/drivers/list';
  urlFour: string = 'accountings/customers/list';
  //urlFive: string = 'quickbooks';

  step = 1;

  data: Array<any> = [];
  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      desc: 'Qu',
      route: '/numbers/accounting',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Tax compliance',
      route: null,
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Invoices',
      route: '/numbers/accounting/invoices',
    },
    /* {
      label: '',
      value: 0,
      icon: 'fas fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Bills',
      route: '/numbers/accounting/external',
    }, */
  ];

  resumenCardsTwo = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Finance',
      route: '/numbers',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-building-columns',
      bgClass: 'bg-white',
      desc: 'Accounting',
      route: '/numbers/accounting',
    },
  ];

  searchText = '';
  filteredData: Array<any> = [];
  sugerenciasBusqueda: string[] = [];
  currentPage: number = 1;
  morePages: boolean = true;
  itemsPerPage: number = 15;
  frequencyMap = {
    1: 'week',
    2: 'biweek',
    3: 'yearly',
  };

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    //this.getData();
    const currentPath = this.router.url.split('/')[2];
    console.log('path:', currentPath);

    if (currentPath === 'freelancers') {
      this.freelancers();
    } else if (currentPath === 'drivers') {
      this.drivers();
    } else if (currentPath === 'customers') {
      this.customers();
    } else {
      this.getData();
    }
  }

  /* getData(): void {
    this.dataService.getData(this.url).subscribe((response) => {
      console.log('personnel', response);
      this.data = response.data;
      this.filteredData = [...this.data];
      //this.getStats();
      //this.getResumenEstados();
      this.actualizarSugerencias();
    });
  }
 */

  /* getData(): void {
    this.dataService
      .getDataTwo(this.url, '', '', this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        console.log('response en accounting', response);

        if (response) {
          this.data = response.data;
          this.morePages = response.data.length === this.itemsPerPage;
          //this.filteredData = [...this.data];

          this.filteredData = this.data.map((item: any) => {
            const key = this.frequencyMap[item.frequency];
          
            const formattedSalary = (value: any) =>
              value ;
            const displaySalary = formattedSalary(item.value);

            //daily: key === 'daily' ? item.value + ' ('+ item.dueDate +')' : '',
            return {
              ...item, // conserva todos los campos originales
              week: key === 'week' ? formattedSalary('WEEKLY') : '',
              biweek: key === 'biweek' ? formattedSalary('BIWEEKLY') : '',
              yearly: key === 'yearly' ? formattedSalary('YEARLY') : '',
              displaySalary: displaySalary,
            };
          });
          //console.log('filteredData', this.filteredData);
          this.actualizarSugerencias();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  } */

  getData(): void {
    this.step = 1;
    this.dataService
      .getDataTwo(this.url, '', '', this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        console.log('response en accounting', response);

        if (response) {
          this.data = response.data;
          this.morePages = response.data.length === this.itemsPerPage;

          this.filteredData = this.data.map((item: any) => {
            const key = this.frequencyMap[item.frequency]; //ej 'week'

            let displaySalary = '';
            if (key === 'week') displaySalary = 'WEEKLY';
            else if (key === 'biweek') displaySalary = 'BIWEEKLY';
            else if (key === 'yearly') displaySalary = 'YEARLY';

            return {
              ...item,
              displaySalary: displaySalary,
            };
          });

          this.actualizarSugerencias();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  deleteData(id: string): void {
    if (!confirm('Desea eliminar el registro?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }

        this.getData();
      });
  }

  filterInfo() {
    const texto = this.searchText.trim().toLowerCase();
    //console.log('texto',texto);
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return (
          (item.firstname && item.firstname.toLowerCase().includes(texto)) ||
          (item.lastname && item.lastname.toLowerCase().includes(texto))
          //(item.phone && item.phone.toLowerCase().includes(texto)) ||
          //(item.role &&
          //  item.role.name &&
          //  item.role.name.toLowerCase().includes(texto)) ||
          //(item.rol_user && item.rol_user.toLowerCase().includes(texto)) ||
          //(item.state && item.state.toLowerCase().includes(texto)) ||
          //(item.city && item.city.toLowerCase().includes(texto))
        );
      });
      //console.log('filteredData',this.filteredData);
    }
    this.getStatsFiltrado();
    this.getResumenEstadosFiltrado();
  }

  getStatsFiltrado() {
    /* this.totalConductores = this.filteredData.length;
    this.totalActivos = this.filteredData.filter((d) => d.status).length;
    this.totalInactivos = this.filteredData.filter((d) => !d.status).length;
    this.ultimoRegistro = this.filteredData.length
      ? this.filteredData[this.filteredData.length - 1].firstname +
        ' ' +
        this.filteredData[this.filteredData.length - 1].lastname
      : '-'; */
  }

  getResumenEstadosFiltrado() {
    /* this.totalNumber = this.filteredData.length;
    this.byCities = new Set(this.filteredData.map((d) => d.city)).size;
    this.active = this.filteredData.filter((d) => d.status === 'active').length;
    this.busy = this.filteredData.filter((d) => d.status === 'busy').length;
    this.pending = this.filteredData.filter(
      (d) => d.status === 'pending'
    ).length;
    this.sanctioned = this.filteredData.filter(
      (d) => d.status === 'sanctioned'
    ).length;

    this.resumenCards[0].value = this.totalConductores;
    this.resumenCards[1].value = this.byCities;
    this.resumenCards[2].value = this.totalActivos;
    this.resumenCards[3].value = this.busy;
    this.resumenCards[4].value = this.totalInactivos;
    this.resumenCards[5].value = this.sanctioned; */
  }

  actualizarSugerencias() {
    const sugerenciasSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.description) sugerenciasSet.add(item.description);
      //if (item.lastname) sugerenciasSet.add(item.lastname);
      //if (item.phone) sugerenciasSet.add(item.phone);
      //if (item.role && item.role.name) sugerenciasSet.add(item.role.name);
      //if (item.rol_user) sugerenciasSet.add(item.rol_user);
      //if (item.state) sugerenciasSet.add(item.state);
      //if (item.city) sugerenciasSet.add(item.city);
    });
    this.sugerenciasBusqueda = Array.from(sugerenciasSet).filter(Boolean);
  }

  freelancers(): void {
    this.step = 2;
    this.dataService
      .getDataTwo(this.urlTwo, '', '', this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        console.log('response en accounting', response);

        if (response) {
          this.data = response.data;
          this.morePages = response.data.length === this.itemsPerPage;

          this.filteredData = this.data.map((item: any) => {
            const key = this.frequencyMap[item.frequency]; //ej 'week'

            let displaySalary = '';
            if (key === 'week') displaySalary = 'WEEKLY';
            else if (key === 'biweek') displaySalary = 'BIWEEKLY';
            else if (key === 'yearly') displaySalary = 'YEARLY';

            return {
              ...item,
              displaySalary: displaySalary,
            };
          });

          this.actualizarSugerencias();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  drivers(): void {
    this.step = 3;
    this.dataService
      .getDataTwo(this.urlThree, '', '', this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        console.log('response en accounting dri', response);

        if (response) {
          this.data = response.data;
          this.morePages = response.data.length === this.itemsPerPage;

          this.filteredData = this.data.map((item: any) => {
            const key = this.frequencyMap[item.frequency]; //ej 'week'

            let displaySalary = '';
            if (key === 'week') displaySalary = 'WEEKLY';
            else if (key === 'biweek') displaySalary = 'BIWEEKLY';
            else if (key === 'yearly') displaySalary = 'YEARLY';

            return {
              ...item,
              displaySalary: displaySalary,
            };
          });

          this.actualizarSugerencias();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  customers(): void {
    this.step = 4;
    this.dataService
      .getDataTwo(this.urlFour, '', '', this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        console.log('response en accounting cus', response);

        if (response) {
          this.data = response.data;
          this.morePages = response.data.length === this.itemsPerPage;

          this.filteredData = this.data.map((item: any) => {
            const key = this.frequencyMap[item.frequency]; //ej 'week'

            let displaySalary = '';
            if (key === 'week') displaySalary = 'WEEKLY';
            else if (key === 'biweek') displaySalary = 'BIWEEKLY';
            else if (key === 'yearly') displaySalary = 'YEARLY';

            return {
              ...item,
              displaySalary: displaySalary,
            };
          });

          this.actualizarSugerencias();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  /*  auth() {
    this.dataService.getData(`${this.urlFive}/auth`).subscribe((response) => {
      console.log('pru data', response);
      window.open(response.url, '_blank');
    });
  } */
}
